import React, { useState } from 'react';
import './WalletModal.scss';
import { Modal } from 'components/Modal/Modal';
import { useMoralis } from 'react-moralis';
import { EthereumIcon, MetamaskFox } from 'components/Icons/Icons';

type WalletModalProps = {
  onClose: () => void;
};

type WalletProvider = 'walletconnect';

export const WalletModal = ({ onClose }: WalletModalProps) => {
  const { authenticate } = useMoralis();
  const [hasClicked, setHasClicked] = useState(false);


  const createAuthHandler = (provider?: WalletProvider) => {
    if(!hasClicked) {
      return async () => {
        setHasClicked(true);
        const config = {
          signingMessage: 'Welcome to the Dusk!',
          ...(provider
            ? {
                provider,
              }
            : {}),
        };
  
        try {
          await authenticate(config);
        } catch (e) {
          alert(e);
        } finally {
          onClose();
        }
      };
    }

  };

  return (
    <Modal
      onClose={onClose}
      modalId="wallet-modal"
      modalHeader={
        <div className="wallet-modal-header">
          <div className="wallet-modal-eth-icon">
            <EthereumIcon />
          </div>
          <h3>Connect your wallet</h3>
          <p>Please connect your Ethereum wallet to proceed</p>
        </div>
      }
      modalBody={
        <div className="wallet-modal-body">
          <div className="wallet-modal-buttons">
            <button className="btn btn-secondary btn-md" onClick={createAuthHandler()} disabled={hasClicked}>
              <div className=" wallet-modal-icon metamask-icon">
                <MetamaskFox />
              </div>
              metamask
            </button>
          </div>
        </div>
      }
    />
  );
};
